import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

import {
  loginRequest,
  saveSession,
  clearSession,
  normalizeUser,
  GECERLI_KULLANICI_TIPLERI,
} from "../../../helpers/auth_client";

/**
 * Giriş.
 *
 * Eskiden burada OData $filter dizesi kuruluyordu:
 *   `Users_Email eq '${email}' and Users_Password eq '${password}'`
 * Şifre alanı kaçırılmadığı için içine tırnak + `or` yazan biri koşulu bozup
 * şifre bilmeden admin kaydını döndürebiliyordu. Ayrıca şifreler düz metin
 * karşılaştırılıyordu. Doğrulama artık tamamen sunucuda, hash üzerinden yapılıyor.
 */
function* loginUser({ payload: { user, history } }) {
  try {
    const identifier = (user.identifier || user.email || "").trim();

    const data = yield call(loginRequest, identifier, user.password);

    if (!data || !data.accessToken || !data.user) {
      yield put(apiError("Giriş yapılamadı, lütfen tekrar deneyin."));
      return;
    }

    // Sunucu alan adlarını camelCase döndürüyor (users_Type_ID); panel PascalCase
    // bekliyor. Kontrolden önce tek şekle indiriyoruz.
    const authUser = normalizeUser(data.user);

    // Panel müşteri, sürücü/çekici ve yöneticiye açıktır; menü ve sayfa içerikleri
    // role göre değişir. Yalnızca tanınmayan bir kullanıcı tipi reddedilir.
    if (!GECERLI_KULLANICI_TIPLERI.includes(Number(authUser.Users_Type_ID))) {
      clearSession();
      yield put(apiError("Bu panele erişim yetkiniz bulunmuyor."));
      return;
    }

    saveSession({
      accessToken: data.accessToken,
      refreshToken: data.refreshToken,
      user: authUser,
    });

    yield put(loginSuccess(authUser));
    history("/dashboard");
  } catch (error) {
    yield put(apiError(error.message || "Giriş hatası."));
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    clearSession();
    yield put(logoutUserSuccess());
    history("/login");
  } catch (error) {
    yield put(apiError(error));
  }
}

// Sosyal giriş panelde kullanılmıyor.
function* socialLogin() {
  try {
    yield put(apiError("Sosyal giriş şu anda desteklenmemektedir."));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
